import React from 'react'

import { DefaultLayoutComponent } from './layout'

import { Loader } from '@percept/mui'

import { ChartBuilder } from '../components/DataWarehouse'

import { useActiveOrgEnvironment } from 'components/Organisation'
import { OrgUnitDataWarehouseContextProvider } from './dataProviders'
import { OrgUnitContext } from '@percept/app-components'


export const ChartBuilderScreen = (): JSX.Element => {
  const { activePlatformUnit } = useActiveOrgEnvironment()

  if( !activePlatformUnit ){
    return (
      <DefaultLayoutComponent>
        <OrgUnitDataWarehouseContextProvider>
          <Loader preset='fullscreen' />
        </OrgUnitDataWarehouseContextProvider>
      </DefaultLayoutComponent>
    )
  }

  return (
    <OrgUnitContext.Provider value={activePlatformUnit}>
      <OrgUnitDataWarehouseContextProvider>
        <DefaultLayoutComponent>
          <ChartBuilder />
        </DefaultLayoutComponent>
      </OrgUnitDataWarehouseContextProvider>
    </OrgUnitContext.Provider>
  )
}

export default ChartBuilderScreen
